import FormatDateTime from "core/utils/FormatDateTime";
import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import SessionContext from "SessionContext";
import ProgressLoader from '../partials/progress-loader';

function UploadStatus({props_id = null}) {
  const location = useLocation();
  const session = useContext(SessionContext);
  const access = session.appState.userCan;
  const userError = <div>Please reach out to Customer Success at <a href="mailto:audiencemaker@speedeondata.com">audiencemaker@speedeondata.com</a> for assistance with this upload.</div>;

  const id = location.state ? location.state.id : props_id;
  const back = location.state ? location.state.back : null;
  const [uploadInfo, setUploadInfo] = useState({name: "", status: ""});
  const [uploadLogs, setUploadLogs] = useState([]);
  const [uploadErrors, setUploadErrors] = useState("");
  const [sortedDown, setSortedDown] = useState(false);

  useEffect(() => {
    if (id) {
      session.query("uploads/get", { id: id })
             .then((response) => {
                setUploadInfo({name: response.filename, status: response.status});
             })
             .catch ((error) => {
               console.log("/uploads/get failed. ", error);
             });

      session.query("uploads/getlog", { id: id })
              .then((response) => {
                if(response.id !== null) {
                  setUploadLogs(response.logs.reverse());
                  setUploadErrors(response.error_text);
                }
              })
              .catch ((error) => {
                console.log("/getlog failed. ", error);
              });
    }
    // eslint-disable-next-line
  }, [id])

  const onHandleSort = () => {
    const sorted = [...uploadLogs];
    setUploadLogs(sorted.reverse());
    setSortedDown(!sortedDown);
  };
 
  return (
    <div className="page">

      {back && (
        <div className="list-header sticky-page-header">
          <Link to={back}>
            <button type="button" className="new-button">
              <i className="bi bi-chevron-left" /> 
              {back === "/uploads" ? "Uploads" : "Location Uploads"}
            </button>
          </Link>
          <h1>Upload Status</h1>
          <i className="spacer" />
        </div>
      )}

      {uploadInfo.name ? (
        <section className="order-status-main">
          {back && (
            <div className="status-header">
              <h5>Upload Name: <span>{uploadInfo.name}</span></h5>
              <h5>Upload Status: <span>{uploadInfo.status}</span></h5>
            </div>
          )}
          <div className="status-body">
            <div className="flex-status-col">
              <div className="history">
                <h6>Upload History</h6>
                <button className="sort-btn" onClick={onHandleSort}>
                  {sortedDown ? <i className="bi bi-sort-down" /> : <i className="bi bi-sort-up-alt" />}
                </button>
              </div>
              {uploadLogs && uploadLogs.length ? 
                <div className="status-list">
                  {uploadLogs.map((log) => <StatusLogs log={log} key={log.message + Math.random()} />)}
                </div>
              : <div>No history found.</div>}
            </div>

            <div className="flex-error-col">
              <h6>Upload Errors</h6><br />
              {
                uploadErrors && uploadErrors.length ? 
                  <StatusError error={
                    access('administration') ? uploadErrors : userError
                  } /> : 
                <div>No errors found.</div>
              }
            </div>
          </div>
        </section>
        ) : <StatusLoading />
      }
      
    </div>
  )
}

export default UploadStatus;

const StatusLogs = ({ log }) => {
  return (
    <div className="status-card">
      <div>
        <FormatDateTime date={log.datetime} />
        <span>: </span>
        <span>
          <b>{log.message}</b>
        </span>
      </div>
    </div>
  );
};

const StatusError = ({error}) => {
  return (
    <div className="error-card">{error}</div>
  );
};

const StatusLoading = () => {
  return (
    <section className="order-status-main">
      <div className="status-loading">
        <div className="loader-wrapper"><ProgressLoader /></div>
        <div className="text-wrapper">Loading...</div>
      </div>
    </section>
  );
};

